import { render, staticRenderFns } from "./producer_cider_table.vue?vue&type=template&id=ece2778e"
import script from "./producer_cider_table.vue?vue&type=script&lang=js"
export * from "./producer_cider_table.vue?vue&type=script&lang=js"
import style0 from "./producer_cider_table.vue?vue&type=style&index=0&id=ece2778e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports